import { render } from "./PreviewItem.vue?vue&type=template&id=037d4340"
import script from "./PreviewItem.vue?vue&type=script&lang=js"
export * from "./PreviewItem.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__